import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";
import { H3 } from "../heading/styles";

export const NavbarWrapper = styled.div`
    margin: 12px ${globalStyles.desktop.pageMargin};
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        margin-left: ${globalStyles.mobile.pageMargin};
        margin-right: ${globalStyles.mobile.pageMargin};
    }
`

export const BrandImage = styled.img`
    height: 3rem;
`

export const Categories = styled.ul`
    list-style-type: none;
`

export const NavItem = styled.li`
    display: inline-block;
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: 600;
    font-size: 14;
`

export const ActionIcon = styled.div`
    padding: 0.5rem;
    box-sizing: border-box;
    &:active {
        background-color: #dbeafe;
    }
`

export const MobileMenu = styled.div`
    position: absolute;
    top: 76px;
    background-color: white;
    width: 100%;
    z-index: 999;
    box-shadow: 0 2px 4px -2px gray;
    margin-left: ${'-' + globalStyles.desktop.pageMargin};
    margin-right: ${'-' + globalStyles.desktop.pageMargin};

    a {
        text-decoration: none;
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        margin-left: ${'-' + globalStyles.mobile.pageMargin};
        margin-right: ${'-' + globalStyles.mobile.pageMargin};
    }
`

export const NavItemMobile = styled(H3)`
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: 600;
    font-size: 14;
    text-align: center;
    text-decoration: none;
`